import React, { useState, useEffect } from 'react';
import cl from "./Prepods.module.css";
import PrepodsList from "./PrepodsList/PrepodsList";
import { teachersAPI, Teacher } from '../../api/api';

const Prepods = () => {
    const [teachers, setTeachers] = useState<Teacher[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const loadTeachers = async () => {
            try {
                setLoading(true);
                const data = await teachersAPI.getAll();
                setTeachers(data);
                setError(null);
            } catch (err) {
                setError('Не удалось загрузить преподавателей');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        loadTeachers();
    }, []);

    if (loading) {
        return (
            <div className={`${cl.home__row}`}>
                <div className={`${cl.home__cell}`}>
                    <div className={`${cl.home__cell__block}`}>
                        <h2>Наши преподаватели</h2>
                        <p>Загрузка преподавателей...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className={`${cl.home__row}`}>
                <div className={`${cl.home__cell}`}>
                    <div className={`${cl.home__cell__block}`}>
                        <h2>Наши преподаватели</h2>
                        <p className="error">{error}</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={`${cl.home__row}`}>
            <div className={`${cl.home__cell}`}>
                <div className={`${cl.home__cell__block}`}>
                    <h2>Наши преподаватели</h2>
                    <p className={cl.home__blockText}>
                        С ребятами занимаются преподаватели, которые умеют объяснять сложные темы простым языком. Для нас важно не только рассказать материал, но и поддержать ученика на пути к его цели по баллам.
                    </p>
                    <PrepodsList prepods={teachers}/>
                </div>
            </div>
        </div>
    );
};

export default Prepods;